// extracted by mini-css-extract-plugin
module.exports = {"root":"Preview_root__3Tm2M","clean":"Preview_clean__2HFd6"};